export default __webpack_public_path__ + "static/media/apple-wallet.58701a98.svg";